import { z } from 'zod';

/** Opaque identifiers are ULIDs/UUIDs generated by the API; we only require non-empty strings. */
export const Id = z.string().min(1).max(64);
export type Id = z.infer<typeof Id>;

/** ISO-8601 timestamp with offset, e.g. 2026-09-23T10:15:30.000Z */
export const Timestamp = z.iso.datetime({ offset: true });
export type Timestamp = z.infer<typeof Timestamp>;

/** BCP-47 language tag, e.g. "ar", "en", "ar-QA", "en-GB". */
export const LanguageTag = z.string().regex(/^[a-zA-Z]{2,3}(-[a-zA-Z0-9]{2,8})*$/);
export type LanguageTag = z.infer<typeof LanguageTag>;

/** ISO-4217 currency code. */
export const CurrencyCode = z.string().length(3).toUpperCase();
export type CurrencyCode = z.infer<typeof CurrencyCode>;

/** Money is always carried as a decimal string to avoid float rounding. */
export const DecimalString = z.string().regex(/^-?\d+(\.\d+)?$/);
export type DecimalString = z.infer<typeof DecimalString>;

export const Channel = z.enum(['web', 'telegram', 'whatsapp', 'email', 'sms', 'system']);
export type Channel = z.infer<typeof Channel>;

export const RiskTier = z.enum(['none', 'low', 'medium', 'high', 'critical']);
export type RiskTier = z.infer<typeof RiskTier>;

export const Confidence = z.number().min(0).max(1);
export type Confidence = z.infer<typeof Confidence>;

export const JsonValue: z.ZodType<JsonValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValue),
    z.record(z.string(), JsonValue),
  ]),
);
export type JsonValue =
  string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };

export const JsonObject = z.record(z.string(), JsonValue);
export type JsonObject = z.infer<typeof JsonObject>;
